import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDays } from 'lucide-react';
import { BOOK_URL } from '../../lib/constants';
import { track } from '../../lib/analytics';
import { openSevaPicker } from './SevaPicker';

const WhatsAppGlyph = ({ className = '' }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.5 14.4c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.48-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.87 1.22 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35z" />
    <path d="M12 2a10 10 0 00-8.6 15.06L2 22l5.06-1.33A10 10 0 1012 2zm0 18.2a8.2 8.2 0 01-4.18-1.14l-.3-.18-3 .79.8-2.92-.2-.31A8.2 8.2 0 1112 20.2z" />
  </svg>
);

export const BookButton = ({ label, className = '', size = 'lg', ...props }) => {
  const pad = size === 'lg' ? 'px-8 py-4 text-sm' : 'px-6 py-3 text-xs';
  const handleClick = () => {
    track('cta_book', label);
    window.open(BOOK_URL, '_blank', 'noopener,noreferrer');
  };
  return (
    <motion.button
      data-testid={`book-btn-${label}`}
      onClick={handleClick}
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      className={`group inline-flex items-center justify-center gap-2.5 rounded-full ${pad} font-sans font-semibold uppercase tracking-[0.15em] text-ink shadow-[0_10px_30px_-8px_rgba(179,139,34,0.6)] transition-colors ${className}`}
      style={{ background: 'linear-gradient(180deg,#F5D97A,#D4AF37 45%,#B38B22)' }}
      {...props}
    >
      <CalendarDays className="h-4 w-4" strokeWidth={2.2} />
      Book Pooja Now
    </motion.button>
  );
};

export const WhatsappButton = ({ label, className = '', size = 'lg', variant = 'solid', ...props }) => {
  const pad = size === 'lg' ? 'px-8 py-4 text-sm' : 'px-6 py-3 text-xs';
  const handleClick = () => {
    track('cta_whatsapp_open_picker', label);
    openSevaPicker(label);
  };
  const base = variant === 'solid'
    ? 'bg-whatsapp text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)]'
    : 'bg-transparent text-whatsapp border border-whatsapp/60';
  return (
    <motion.button
      data-testid={`whatsapp-btn-${label}`}
      onClick={handleClick}
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      className={`inline-flex items-center justify-center gap-2.5 rounded-full ${pad} font-sans font-semibold uppercase tracking-[0.15em] transition-colors ${base} ${className}`}
      {...props}
    >
      <WhatsAppGlyph className="h-5 w-5" />
      Chat on WhatsApp
    </motion.button>
  );
};

export { WhatsAppGlyph };
